module.exports = __webpack_public_path__ + "img/avatar.b72914ac.svg";